import { BaseComponent } from '../../base-component';
import { EventTracking } from './event-tracking';
import { ViewTracking } from './view-tracking';
import { VisibilityTracking } from './visibility-tracking';

export class TrackingComponent extends BaseComponent {
    public rootSelector = '.js_pdp_tracking_component';

    constructor(
        private eventTracking: EventTracking,
        private viewTracking: ViewTracking,
        private visibilityTracking: VisibilityTracking
    ) {
        super();
    }

    public async init(): Promise<void> {
        this.viewTracking.registerViewTrackingFromCode();
        this.eventTracking.registerEventTrackingFromCode();
        this.eventTracking.delegateHtmlClickTracking();
    }

    public async onHtmlLoaded(): Promise<void> {
        if (!this.isPresent()) {
            return;
        }

        await this.performViewTracking();
        await this.performVisibilityTracking();
    }

    private async performViewTracking() {
        this.viewTracking.performHtmlViewTracking();

        const variationTrackingJson = this.getChildElement('#js_pdp_variationTrackingData')?.textContent;
        if (variationTrackingJson) {
            this.trackViewFeatures(JSON.parse(variationTrackingJson));
        }
    }

    private async performVisibilityTracking() {
        const visibilityTrackingData = this.visibilityTracking.getVisibilityTrackingData();
        if (visibilityTrackingData) {
            const variationId = this.getRootElement().dataset.variationId || '';
            this.visibilityTracking.submitMiniActionWithVariationId(variationId);
            this.trackViewFeatures(visibilityTrackingData);
            this.visibilityTracking.registerIntersectionObserver();
        }
    }
}
